module.exports = __webpack_public_path__ + "static/media/quotes.527ae208.svg";